import styled, { css } from 'styled-components';
import { BREAKPOINTS } from '../../constants/layout.mjs';
import { theme } from '../../constants/theme.mjs';
"use strict";
const Container = styled.div`
  display: ${({
  show
}) => show ? "block" : "none"};
  min-height: ${({
  minHeight
}) => minHeight != void 0 ? minHeight + "px" : "48px"};
  width: ${({
  width
}) => width ? width + "px" : "auto"};
  box-sizing: border-box;

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    width: 100%;
    max-width: ${({
  width
}) => width ? width + "px" : void 0};
  }

  ${({
  clean
}) => !clean && css`
      box-shadow:
        0 0 2px rgba(0 0 0 / 0.06),
        0 24px 32px rgba(0 0 0 / 0.04),
        0 16px 24px rgba(0 0 0 / 0.04),
        0 4px 8px rgba(0 0 0 / 0.04),
        0 0 1px rgba(0 0 0 / 0.04);
      border-radius: 6px;
      background: ${theme.colors.white};
    `}
`;
export { Container };
//# sourceMappingURL=StaticModal.styles.mjs.map
